import React, { Component } from "react";
import _ from "lodash";
import classnames from "classnames";
import { FormGroup, FormControl, Glyphicon } from "react-bootstrap";

import {
  asyncContainer,
  Typeahead as BootstrapTypeahead
} from "react-bootstrap-typeahead";
import styles from "./Typeahead.scss";
import locationIcon from "../../../assets/images/location-icon.svg";

const AsyncTypeahead = asyncContainer(BootstrapTypeahead);
class Typeahead extends Component {
  constructor(props) {
    super(props);

    this.state = {
      focus: this.props.focus || false,
      selected: this.props.selected || null
    };
  }

  componentDidUpdate() {
    if (this.props.selected && !this.state.selected) {
      this.handleChange(this.props.selected);
    }
  }

  handleBlur(event) {
    this.setState({ focus: false }, () => {
      // Select first option onBlur if exists
      if (_.isEmpty(this.state.selected) && !_.isEmpty(this.props.options)) {
        const value = event.target.value || "";
        const selected = _.filter(this.props.options, option => {
          if (!option || !option.name) return false;
          return option.name.toLowerCase() === value.toLowerCase().trim();
        });
        this.handleChange(selected);
      }
    });
  }

  handleChange(selected) {
    const onChange = selected => {
      if (this.props.input.onChange) {
        this.props.input.onChange(selected);
      }
    };

    this.setState({ selected }, () => onChange(selected));
  }

  handleFocus() {
    this.setState({ focus: true });
  }

  handleInputChange(text) {
    if (this.props.selected) {
      this.setState({ query: text });
    } else {
      this.setState({ query: text, selected: null });
    }
  }

  render() {
    const {
      allowNew,
      icon,
      isAsync,
      isLoading,
      labelKey,
      minLength,
      name,
      newSelectionPrefix,
      options,
      paginationText,
      placeholder,
      selected,
      meta: { touched, error, warning, valid },
      ...props
    } = this.props;

    let validationState =
      (touched && valid && "success") ||
      (touched && error && "error") ||
      (touched && warning && "warning") ||
      null;

    let feedback = icon ? (
      <Glyphicon
        className={styles.icon}
        glyph={icon}
        onClick={this.handleClick}
      />
    ) : (
      <FormControl.Feedback className={styles.inputFeedback} />
    );

    feedback =
      icon && icon === "map-marker" ? (
        <img src={locationIcon} className={styles.customIcon} />
      ) : (
        feedback
      );

    return (
      <FormGroup className={styles.form} validationState={validationState}>
        <label
          className={classnames({
            [styles.placeholder]: true,
            [styles.placeholderActive]:
              this.state.focus ||
              (this.typeahead && this.typeahead.state.query) ||
              (this.props.input && this.props.input.value.length)
          })}
          onClick={() =>
            this.typeahead
              .getInstance()
              .getInput()
              .focus()
          }
        >
          {placeholder}
        </label>
        {isAsync ? (
          <AsyncTypeahead
            allowNew={allowNew || false}
            className={classnames({
              [styles.typeahead]: true,
              [styles.typeaheadFocus]:
                this.state.focus ||
                (this.typeahead && this.typeahead.state.query) ||
                (this.props.input && this.props.input.value.length)
            })}
            highlightOnlyResult={!allowNew}
            isLoading={isLoading}
            labelKey={labelKey}
            minLength={minLength}
            multiple={false}
            name={name}
            newSelectionPrefix={newSelectionPrefix}
            options={options}
            paginationText={paginationText}
            ref={typeahead => (this.typeahead = typeahead)}
            selected={this.state.selected || selected || null}
            useCache={false}
            onBlur={() => {
              this.handleBlur.bind(this);
              if (this.props.focusOut) {
                this.props.focusOut(this.state.query, this.state.selected);
              }
            }}
            onChange={this.handleChange.bind(this)}
            onFocus={this.handleFocus.bind(this)}
            onInputChange={this.handleInputChange.bind(this)}
            onSearch={query => {
              this.props.onSearch(query);
            }}
            {...props}
          />
        ) : (
          <BootstrapTypeahead
            allowNew={allowNew || false}
            className={styles.typeahead}
            highlightOnlyResult={true}
            labelKey={labelKey}
            minLength={minLength}
            multiple={false}
            newSelectionPrefix={newSelectionPrefix}
            name={name}
            options={options}
            paginationText={paginationText}
            ref={typeahead => (this.typeahead = typeahead)}
            selected={this.state.selected || selected || null}
            onBlur={this.handleBlur.bind(this)}
            onChange={this.handleChange.bind(this)}
            onFocus={this.handleFocus.bind(this)}
          />
        )}
        {touched && error && _.isString(error) && (
          <p className={styles.error}>{error}</p>
        )}

        {touched &&
          error &&
          Array.isArray(error) &&
          error.map(({ message, index }) => (
            <p key={index} className={styles.error}>
              {message}
            </p>
          ))}
        {feedback}
      </FormGroup>
    );
  }
}

export default Typeahead;



// WEBPACK FOOTER //
// ./src/components/common/typeahead/Typeahead.js